module.exports = __webpack_public_path__ + "static/img/200038.4eed5655.png";